import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TechnologyDashboard from "./TechnologyDashboard";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";

function TechnologyDashboardPage({ subcategoryToken }) {
  return (
    <DashboardLayout>
      <MDBox
             sx={{
               display: {
                 xs: "block",
                 sm: "block",
                 md: "none",
               },
             }}
           >
             <AppHeader />
           </MDBox>
      <TechnologyDashboard subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}

export default TechnologyDashboardPage;
